import "./style.scss";
import { Slide, toast } from "react-toastify";
import Swal from "sweetalert2";
import { getUsers } from "../redux/features/user/_userAction";
import { getAgentSubscriptions, getClubSubscriptions, getMemberSubscriptions, getScoutSubscriptions } from "../redux/features/subscription/_subscriptionAction";
import { getMemberPlans } from "../redux/features/plan/_planAction";
import { getNewsLetters } from "../redux/features/news-letter/_newsLetterAction";
import { getContacts } from "../redux/features/contact/_contactAction";

export const commonSwtichCases = (id: any, searchValue: any, dispatch: any) => {
    searchValue = encodeURIComponent(searchValue)
    switch (id) {
        case 'User':
            dispatch(getUsers({ search: searchValue.trim(), page: 1, limit: 10 }))
            break;
        case 'MemberSubscription':
            dispatch(getMemberSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'MemberPlan':
            dispatch(getMemberPlans({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'Subscribers':
            dispatch(getNewsLetters({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'Contact':
            dispatch(getContacts({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'ScoutSubscription':
            dispatch(getScoutSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'AgentSubscription':
            dispatch(getAgentSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
        case 'ClubSubscription':
            dispatch(getClubSubscriptions({ search: searchValue.trim(), page: 1, limit: 10 }));
            break;
            
        default:
    }
}

export const conFirmMessage = (values) => {
    return Swal.fire(values)
}

export const commonUserStatusSwtichCases = (id: any, values: any, dispatch: any) => {
    switch (id) {
        case 'USER':
            dispatch(getUsers({ page: 1, limit: 10 }))
            break;
        default:
    }
}

export const docUrl = (images: any) => {
    const urlArray: any = [];
    for (let i = 0; i < images.length; i++) {
        urlArray.push(images[i].url);
    }
    return urlArray
}

export const toastifyOptions: any = {
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Slide,
};

export const notify = (message: any, type: any) => {
    if (type === 'error') {
        return toast.error(message, toastifyOptions);
    } else if (type === 'info') {
        return toast.info(message, toastifyOptions);
    } else if (type === 'warning') {
        return toast.warning(message, toastifyOptions);
    } else if (type === 'success') {
        return toast.success(message, toastifyOptions);
    }
};


